/******************************************************************************
 *
 * FILE:
 * src/modules/wms/workspace/executor/components/PriorityWorkCard.jsx
 *
 * MODULE:
 * Work Management System (WMS)
 *
 * FEATURE:
 * Executor Workspace
 *
 * DESCRIPTION:
 * Displays the highest priority work assigned to the executor.
 *
 * RESPONSIBILITIES
 * ----------------
 * ✓ Highlight highest priority work
 * ✓ Show reason for priority
 * ✓ Navigate to Work Details
 *
 ******************************************************************************/

import React from "react";
//import { useNavigate } from "react-router-dom";

export default function PriorityWorkCard({

    work,
    onExecute,

}) {

    //const navigate = useNavigate();

    if (!work) {

        return (

            <div className="card shadow-sm h-100">

                <div className="card-body text-center text-muted py-5">

                    <i
                        className="fas fa-check-circle fa-2x mb-3 text-success"
                    />

                    <h6>

                        No Priority Work

                    </h6>

                    <small>

                        Great! There are no urgent works.

                    </small>

                </div>

            </div>

        );

    }

    return (

        <div className="card shadow-sm border-0 h-100">

            <div
                className="card-header text-white"
                style={{
                    background:
                        "linear-gradient(90deg,#dc3545,#ff6b6b)"
                }}
            >

                <div className="fw-bold">

                    Highest Priority

                </div>

                <small>

                    Recommended work to start next

                </small>

            </div>

            <div className="card-body">

                <div className="mb-3">

                    <small className="text-muted">

                        Work Number

                    </small>

                    <div className="fw-bold">

                        {work.work_no}

                    </div>

                </div>

                <div className="mb-3">

                    <small className="text-muted">

                        Title

                    </small>

                    <div>

                        {work.title}

                    </div>

                </div>

                <div className="row mb-3">

                    <div className="col-6">

                        <small className="text-muted">

                            Priority

                        </small>

                        <div className="fw-bold text-danger">

                            {work.priority}

                        </div>

                    </div>

                    <div className="col-6">

                        <small className="text-muted">

                            Status

                        </small>

                        <div>

                            {work.status}

                        </div>

                    </div>

                </div>

                <div className="row mb-3">

                    <div className="col-6">

                        <small className="text-muted">

                            Due Date

                        </small>

                        <div>

                            {work.due_date}

                        </div>

                    </div>

                    <div className="col-6">

                        <small className="text-muted">

                            Progress

                        </small>

                        <div>

                            {work.progress}%

                        </div>

                    </div>

                </div>

                <div
                    className="alert alert-danger py-2 mb-0"
                >

                    <i className="fas fa-exclamation-triangle me-2" />

                    <strong>

                        Reason :

                    </strong>

                    {" "}

                    {work.reason || "Highest Priority"}

                </div>

            </div>

            <div className="card-footer bg-white text-end">

                <button

                    className="btn btn-danger"

                    onClick={() =>

                        onExecute?.(work.id)

                    }

                >

                    <i className="fas fa-play me-2" />

                    Start Work

                </button>

            </div>

        </div>

    );

}